import logoImg from "@/assets/logo.png";

export const LOGO = logoImg;

export const CONTACT = {
  phone: "+31 6 13 76 67 01",
  phoneRaw: "+31613766701",
  whatsapp: "31613766701",
  email: "gilano@northlinerecruitment.nl",
};

export const languages = ["NL", "EN", "PL"];

export const t = {
  NL: {
    nav_benefits: "Waarom wij",
    nav_process: "Werkwijze",
    nav_requirements: "Eisen",
    nav_employers: "Werkgevers",
    nav_reviews: "Recensies",
    nav_apply: "Solliciteer",
    hero_tag: "WERVING & SELECTIE • TRANSPORT • NEDERLAND",
    hero_title_1: "WIJ BEMIDDELEN",
    hero_title_2: "CE CHAUFFEURS",
    hero_sub: "Northline Recruitment is jouw bemiddelingsbureau voor werving & selectie in transport. Wij koppelen CE-chauffeurs aan de beste werkgevers in heel Nederland — persoonlijk, snel en volledig gratis voor kandidaten.",
    hero_cta: "Solliciteer direct",
    hero_cta2: "Bel ons",
    stat_1: "50+", stat_1l: "Werkgevers in ons netwerk",
    stat_2: "200+", stat_2l: "Chauffeurs bemiddeld",
    stat_3: "48u", stat_3l: "Gemiddelde reactietijd",
    benefits_title: "WAAROM VIA NORTHLINE?",
    benefits_sub: "Wij verbinden talent, versterken bedrijven en bouwen aan morgen. Als jouw bemiddelaar staan we volledig aan jouw kant.",
    b1_t: "Groot Werkgeversnetwerk", b1_d: "Toegang tot 50+ transportbedrijven. Wij vinden de baan die écht bij je past.",
    b2_t: "Gratis & Vrijblijvend", b2_d: "Onze bemiddeling is 100% kosteloos voor kandidaten. Geen verplichtingen.",
    b3_t: "Beste Voorwaarden", b3_d: "Wij onderhandelen voor jou over salaris, toeslagen en een vast contract.",
    b4_t: "Persoonlijke Bemiddeling", b4_d: "Eén vaste consultant die je van intake tot eerste werkdag begeleidt.",
    b5_t: "Werk in heel NL", b5_d: "Vacatures door heel Nederland — wij zoeken zo dicht mogelijk bij huis.",
    b6_t: "Snelle Match", b6_d: "Papieren op orde? Dan kun je vaak binnen enkele dagen aan de slag.",
    process_tag: "ZO WERKT HET",
    process_title: "ONZE WERKWIJZE",
    process_sub: "Van sollicitatie tot je eerste rit — in vier heldere stappen.",
    steps: [
      { t: "Solliciteer", d: "Vul het formulier in of bel ons. Binnen 48 uur nemen we contact op." },
      { t: "Intake & Screening", d: "Persoonlijk kennismakingsgesprek. We checken je papieren en wensen." },
      { t: "De Match", d: "Wij koppelen je aan de werkgever die het beste bij jou past." },
      { t: "Aan het Werk", d: "Contract getekend en rijden maar. Wij blijven je begeleiden." },
    ],
    req_title: "WAT VRAGEN WIJ?",
    req_sub: "Herken jij jezelf hierin? Dan brengen we je graag in contact met een topwerkgever.",
    req: [
      "Geldig rijbewijs C/CE",
      "Geldige code 95 (vakbekwaamheid)",
      "Bestuurderskaart (tachograaf)",
      "Goede beheersing van Nederlands, Engels of Pools",
      "Flexibele en betrouwbare instelling",
      "Woonachtig in of dichtbij Nederland",
    ],
    emp_tag: "VOOR WERKGEVERS",
    emp_title: "OP ZOEK NAAR CHAUFFEURS?",
    emp_sub: "Northline vindt en selecteert gekwalificeerde CE-chauffeurs voor uw transportbedrijf. Wij doen uitsluitend werving & selectie — géén detachering. De chauffeur komt direct bij u in dienst; wij nemen het zoeken en screenen volledig uit handen.",
    emp_points: ["Vooraf gescreende, gekwalificeerde kandidaten", "No cure, no pay — u betaalt alléén bij een succesvolle plaatsing", "Eén vaste fee per plaatsing, geen detacheringsmarge"],
    emp_cta: "Neem contact op",
    form_title: "SOLLICITEER NU",
    form_sub: "Vul het formulier in. Onze consultant neemt binnen 48 uur contact op.",
    f_name: "Volledige naam",
    f_phone: "Telefoonnummer",
    f_email: "E-mailadres",
    f_license: "Rijbewijs / rijbewijzen",
    f_exp: "Jaren ervaring",
    f_avail: "Beschikbaarheid",
    f_msg: "Bericht (optioneel)",
    f_submit: "Verstuur sollicitatie",
    f_sending: "Versturen...",
    f_success: "Bedankt! Onze consultant neemt snel contact met je op.",
    f_error: "Er ging iets mis. Probeer het opnieuw.",
    exp_opts: ["Minder dan 1 jaar", "1-3 jaar", "3-5 jaar", "5+ jaar"],
    lic_opts: ["Rijbewijs C", "Rijbewijs CE", "C + CE", "In opleiding"],
    avail_opts: ["Direct", "Binnen 2 weken", "Binnen 1 maand", "In overleg"],
    f_certs: "Certificaten (selecteer alles wat van toepassing is)",
    cert_opts: ["Code 95", "ADR Basis", "ADR Tank", "ADR Klasse 1 (Explosieven)", "ADR Klasse 7 (Radioactief)", "Heftruck", "Reachtruck", "Autolaadkraan (kraancertificaat)", "VCA", "Chauffeurskaart (tachograaf)", "Digitale tachograaf", "Containervervoer", "Koeltransport (vers)", "Boordcomputer ervaring"],
    contact_title: "LIEVER DIRECT CONTACT?",
    contact_sub: "Bel of stuur ons een WhatsApp-bericht. Onze consultants helpen je graag verder.",
    footer_tag: "Verbindt talent. Versterkt bedrijven. Bouwt aan morgen.",
    footer_slogan: "Betrouwbaar. Gedreven. Nooit stil.",
    footer_about: "Northline Recruitment — bemiddelingsbureau voor werving & selectie in transport.",
    f_cv: "CV / documenten (optioneel)",
    faq_tag: "FAQ", faq_title: "VEELGESTELDE VRAGEN", faq_sub: "Alles over solliciteren via Northline.",
    faq: [
      { q: "Wat kost het mij als kandidaat?", a: "Niets. Onze bemiddeling is 100% gratis en vrijblijvend voor chauffeurs." },
      { q: "Hoe snel kan ik aan het werk?", a: "Zijn je papieren op orde, dan vaak binnen enkele dagen na de intake." },
      { q: "Welke rijbewijzen heb ik nodig?", a: "Minimaal rijbewijs C/CE met geldige code 95 en bestuurderskaart." },
      { q: "Kom ik direct in dienst bij de werkgever?", a: "Ja. Wij doen alleen werving & selectie; je tekent rechtstreeks bij de werkgever." },
    ],
    vac_tag: "VACATURES", vac_title: "ACTUELE VACATURES", vac_sub: "Een greep uit onze openstaande posities. Staat jouw regio er niet bij? Solliciteer alsnog.",
    vacancies: [
      { title: "CE-chauffeur nationaal transport", location: "Rotterdam / Rijnmond", type: "Vast contract" },
      { title: "CE-chauffeur distributie", location: "Venlo / Limburg", type: "Vast contract" },
      { title: "CE-chauffeur containervervoer", location: "Amsterdam", type: "Fulltime" },
      { title: "CE-chauffeur koeltransport", location: "Tilburg / Brabant", type: "Vast contract" },
    ],
    cookie_text: "Wij gebruiken alleen functionele cookies voor een goede werking van de site.",
    cookie_accept: "Akkoord",
    privacy_link: "Privacyverklaring",
    privacy_title: "Privacyverklaring",
    privacy_body: "Northline Recruitment verwerkt de gegevens die je via het sollicitatieformulier invult (naam, contactgegevens, rijbewijs, certificaten, ervaring en eventueel je cv) uitsluitend om je te bemiddelen naar passend werk. Wij delen je gegevens alleen met potentiële werkgevers na jouw toestemming en bewaren ze niet langer dan nodig. Je kunt op elk moment inzage, correctie of verwijdering aanvragen via gilano@northlinerecruitment.nl.",
    reviews_tag: "RECENSIES",
    reviews_title: "WAT CHAUFFEURS ZEGGEN",
    reviews_sub: "Echte ervaringen van chauffeurs die wij bemiddeld hebben.",
    reviews_rating_label: "gemiddelde beoordeling",
    reviews: [
      { name: "Jan de Vries", role: "CE-chauffeur, Rotterdam", text: "Binnen een week had ik een vast contract bij een top transportbedrijf. Northline regelde alles en de communicatie was top.", rating: 5 },
      { name: "Marek Kowalski", role: "CE-chauffeur, Venlo", text: "Professionele begeleiding van begin tot eind. Mijn consultant hield me overal van op de hoogte. Echt een aanrader!", rating: 5 },
      { name: "Dennis Bakker", role: "CE-chauffeur, Tilburg", text: "Ik zocht werk dichter bij huis en Northline vond precies wat ik wilde. Snel, eerlijk en persoonlijk.", rating: 5 },
      { name: "Piotr Nowak", role: "CE-chauffeur, Amsterdam", text: "Prima geregeld, ook met mijn ADR-papieren. Salaris was beter dan verwacht. Bedankt Northline!", rating: 5 },
      { name: "Ahmed El Amrani", role: "CE-chauffeur, Utrecht", text: "Eindelijk een bureau dat naar je luistert. Geen loze beloftes, gewoon een goede baan geregeld.", rating: 4 },
      { name: "Tomasz Wójcik", role: "CE-chauffeur, Eindhoven", text: "Snelle reactie en netjes alles op papier. Ik rijd nu met veel plezier voor een mooie werkgever.", rating: 5 },
    ],
  },
  EN: {
    nav_benefits: "Why us",
    nav_process: "How it works",
    nav_requirements: "Requirements",
    nav_employers: "Employers",
    nav_reviews: "Reviews",
    nav_apply: "Apply",
    hero_tag: "RECRUITMENT & SELECTION • TRANSPORT • NETHERLANDS",
    hero_title_1: "WE PLACE",
    hero_title_2: "CE DRIVERS",
    hero_sub: "Northline Recruitment is your recruitment & selection agency for transport. We match CE drivers with the best employers across the Netherlands — personal, fast and completely free for candidates.",
    hero_cta: "Apply now",
    hero_cta2: "Call us",
    stat_1: "50+", stat_1l: "Employers in our network",
    stat_2: "200+", stat_2l: "Drivers placed",
    stat_3: "48h", stat_3l: "Average response time",
    benefits_title: "WHY THROUGH NORTHLINE?",
    benefits_sub: "We connect talent, strengthen companies and build tomorrow. As your agency, we are fully on your side.",
    b1_t: "Large Employer Network", b1_d: "Access to 50+ transport companies. We find the job that truly fits you.",
    b2_t: "Free & Non-binding", b2_d: "Our placement is 100% free for candidates. No obligations.",
    b3_t: "Best Conditions", b3_d: "We negotiate salary, allowances and a permanent contract on your behalf.",
    b4_t: "Personal Placement", b4_d: "One dedicated consultant guiding you from intake to your first workday.",
    b5_t: "Work Across NL", b5_d: "Vacancies throughout the Netherlands — we search as close to home as possible.",
    b6_t: "Fast Match", b6_d: "Paperwork in order? You can often start within days.",
    process_tag: "HOW IT WORKS",
    process_title: "OUR PROCESS",
    process_sub: "From application to your first drive — in four clear steps.",
    steps: [
      { t: "Apply", d: "Fill in the form or call us. We contact you within 48 hours." },
      { t: "Intake & Screening", d: "Personal introduction. We check your documents and wishes." },
      { t: "The Match", d: "We match you with the employer that fits you best." },
      { t: "Start Working", d: "Contract signed and off you go. We keep supporting you." },
    ],
    req_title: "WHAT WE ASK",
    req_sub: "Recognise yourself? Then we would love to connect you with a top employer.",
    req: [
      "Valid C/CE driving licence",
      "Valid code 95 (professional competence)",
      "Driver card (tachograph)",
      "Good command of Dutch, English or Polish",
      "Flexible and reliable attitude",
      "Living in or near the Netherlands",
    ],
    emp_tag: "FOR EMPLOYERS",
    emp_title: "LOOKING FOR DRIVERS?",
    emp_sub: "Northline finds and selects qualified CE drivers for your transport company. We do recruitment & selection only — no secondment. The driver joins your team directly; we fully handle the search and screening.",
    emp_points: ["Pre-screened, qualified candidates", "No cure, no pay — you only pay on a successful placement", "One fixed fee per placement, no secondment margin"],
    emp_cta: "Get in touch",
    form_title: "APPLY NOW",
    form_sub: "Fill in the form. Our consultant will contact you within 48 hours.",
    f_name: "Full name",
    f_phone: "Phone number",
    f_email: "Email address",
    f_license: "Licence(s)",
    f_exp: "Years of experience",
    f_avail: "Availability",
    f_msg: "Message (optional)",
    f_submit: "Send application",
    f_sending: "Sending...",
    reviews_tag: "REVIEWS",
    reviews_title: "WHAT DRIVERS SAY",
    reviews_sub: "Real experiences from drivers we have placed.",
    reviews_rating_label: "average rating",
    reviews: [
      { name: "Jan de Vries", role: "CE driver, Rotterdam", text: "Within a week I had a permanent contract at a top transport company. Northline arranged everything and the communication was great.", rating: 5 },
      { name: "Marek Kowalski", role: "CE driver, Venlo", text: "Professional guidance from start to finish. My consultant kept me informed about everything. Highly recommended!", rating: 5 },
      { name: "Dennis Bakker", role: "CE driver, Tilburg", text: "I was looking for work closer to home and Northline found exactly what I wanted. Fast, honest and personal.", rating: 5 },
      { name: "Piotr Nowak", role: "CE driver, Amsterdam", text: "Everything well arranged, including my ADR papers. Salary was better than expected. Thanks Northline!", rating: 5 },
      { name: "Ahmed El Amrani", role: "CE driver, Utrecht", text: "Finally an agency that listens. No empty promises, just a good job sorted out.", rating: 4 },
      { name: "Tomasz Wójcik", role: "CE driver, Eindhoven", text: "Quick response and everything neatly on paper. I now drive with pleasure for a great employer.", rating: 5 },
    ],
    f_success: "Thank you! Our consultant will contact you soon.",
    f_error: "Something went wrong. Please try again.",
    exp_opts: ["Less than 1 year", "1-3 years", "3-5 years", "5+ years"],
    lic_opts: ["Licence C", "Licence CE", "C + CE", "In training"],
    avail_opts: ["Immediately", "Within 2 weeks", "Within 1 month", "To discuss"],
    f_certs: "Certificates (select all that apply)",
    cert_opts: ["Code 95", "ADR Basic", "ADR Tank", "ADR Class 1 (Explosives)", "ADR Class 7 (Radioactive)", "Forklift", "Reach truck", "Truck-mounted crane", "VCA (safety)", "Driver card (tachograph)", "Digital tachograph", "Container transport", "Refrigerated transport", "On-board computer experience"],
    contact_title: "PREFER DIRECT CONTACT?",
    contact_sub: "Call or send us a WhatsApp message. Our consultants are happy to help.",
    footer_tag: "Connects talent. Strengthens companies. Builds tomorrow.",
    footer_slogan: "Reliable. Driven. Never still.",
    footer_about: "Northline Recruitment — recruitment & selection agency for transport.",
    f_cv: "CV / documents (optional)",
    faq_tag: "FAQ", faq_title: "FREQUENTLY ASKED", faq_sub: "Everything about applying through Northline.",
    faq: [
      { q: "What does it cost me as a candidate?", a: "Nothing. Our placement is 100% free and non-binding for drivers." },
      { q: "How quickly can I start?", a: "If your paperwork is in order, often within days after the intake." },
      { q: "Which licences do I need?", a: "At least a C/CE licence with a valid code 95 and driver card." },
      { q: "Do I join the employer directly?", a: "Yes. We only do recruitment & selection; you sign directly with the employer." },
    ],
    vac_tag: "VACANCIES", vac_title: "CURRENT VACANCIES", vac_sub: "A selection of our open positions. Your region not listed? Apply anyway.",
    vacancies: [
      { title: "CE driver national transport", location: "Rotterdam / Rijnmond", type: "Permanent" },
      { title: "CE driver distribution", location: "Venlo / Limburg", type: "Permanent" },
      { title: "CE driver container transport", location: "Amsterdam", type: "Full-time" },
      { title: "CE driver refrigerated transport", location: "Tilburg / Brabant", type: "Permanent" },
    ],
    cookie_text: "We only use functional cookies for the site to work properly.",
    cookie_accept: "Accept",
    privacy_link: "Privacy statement",
    privacy_title: "Privacy statement",
    privacy_body: "Northline Recruitment processes the data you enter in the application form (name, contact details, licence, certificates, experience and optionally your CV) solely to place you in suitable work. We only share your data with potential employers after your consent and do not keep it longer than necessary. You can request access, correction or deletion at any time via gilano@northlinerecruitment.nl.",
  },
  PL: {
    nav_benefits: "Dlaczego my",
    nav_process: "Jak działamy",
    nav_reviews: "Opinie",
    nav_requirements: "Wymagania",
    nav_employers: "Pracodawcy",
    nav_apply: "Aplikuj",
    hero_tag: "REKRUTACJA I SELEKCJA • TRANSPORT • HOLANDIA",
    hero_title_1: "POŚREDNICZYMY",
    hero_title_2: "KIEROWCY CE",
    hero_sub: "Northline Recruitment to Twoja agencja rekrutacji i selekcji w transporcie. Łączymy kierowców CE z najlepszymi pracodawcami w całej Holandii — osobiście, szybko i całkowicie bezpłatnie dla kandydatów.",
    hero_cta: "Aplikuj teraz",
    hero_cta2: "Zadzwoń",
    stat_1: "50+", stat_1l: "Pracodawców w sieci",
    stat_2: "200+", stat_2l: "Kierowców zatrudnionych",
    stat_3: "48h", stat_3l: "Średni czas odpowiedzi",
    benefits_title: "DLACZEGO PRZEZ NORTHLINE?",
    benefits_sub: "Łączymy talenty, wzmacniamy firmy i budujemy jutro. Jako Twoja agencja jesteśmy całkowicie po Twojej stronie.",
    b1_t: "Duża Sieć Pracodawców", b1_d: "Dostęp do ponad 50 firm transportowych. Znajdziemy pracę idealną dla Ciebie.",
    b2_t: "Bezpłatnie i Bez Zobowiązań", b2_d: "Nasze pośrednictwo jest w 100% darmowe dla kandydatów. Bez zobowiązań.",
    b3_t: "Najlepsze Warunki", b3_d: "Negocjujemy w Twoim imieniu wynagrodzenie, dodatki i stałą umowę.",
    b4_t: "Osobiste Pośrednictwo", b4_d: "Jeden konsultant prowadzi Cię od rozmowy do pierwszego dnia pracy.",
    b5_t: "Praca w całej Holandii", b5_d: "Oferty w całej Holandii — szukamy jak najbliżej Twojego domu.",
    b6_t: "Szybkie Dopasowanie", b6_d: "Dokumenty w porządku? Często możesz zacząć w kilka dni.",
    process_tag: "JAK TO DZIAŁA",
    process_title: "NASZ PROCES",
    process_sub: "Od aplikacji do pierwszego kursu — w czterech jasnych krokach.",
    steps: [
      { t: "Aplikuj", d: "Wypełnij formularz lub zadzwoń. Skontaktujemy się w 48 godzin." },
      { t: "Rozmowa i Weryfikacja", d: "Osobiste poznanie. Sprawdzamy dokumenty i oczekiwania." },
      { t: "Dopasowanie", d: "Łączymy Cię z pracodawcą, który najlepiej do Ciebie pasuje." },
      { t: "Do Pracy", d: "Umowa podpisana i ruszasz. Wspieramy Cię przez cały czas." },
    ],
    req_title: "CZEGO WYMAGAMY?",
    req_sub: "Poznajesz siebie? Chętnie połączymy Cię z najlepszym pracodawcą.",
    req: [
      "Ważne prawo jazdy C/CE",
      "Ważny kod 95 (kwalifikacja zawodowa)",
      "Karta kierowcy (tachograf)",
      "Dobra znajomość niderlandzkiego, angielskiego lub polskiego",
      "Elastyczne i rzetelne podejście",
      "Zamieszkanie w Holandii lub w pobliżu",
    ],
    emp_tag: "DLA PRACODAWCÓW",
    emp_title: "SZUKASZ KIEROWCÓW?",
    emp_sub: "Northline znajduje i selekcjonuje wykwalifikowanych kierowców CE dla Twojej firmy transportowej. Zajmujemy się wyłącznie rekrutacją i selekcją — bez oddelegowania. Kierowca zostaje zatrudniony bezpośrednio u Ciebie; my w pełni zajmujemy się poszukiwaniem i weryfikacją.",
    emp_points: ["Wstępnie zweryfikowani, wykwalifikowani kandydaci", "No cure, no pay — płacisz tylko za skuteczne zatrudnienie", "Jedna stała opłata za zatrudnienie, bez marży za oddelegowanie"],
    emp_cta: "Skontaktuj się",
    form_title: "APLIKUJ TERAZ",
    form_sub: "Wypełnij formularz. Nasz konsultant skontaktuje się w ciągu 48 godzin.",
    f_name: "Imię i nazwisko",
    f_phone: "Numer telefonu",
    f_email: "Adres e-mail",
    f_license: "Prawo jazdy",
    f_exp: "Lata doświadczenia",
    f_avail: "Dostępność",
    f_msg: "Wiadomość (opcjonalnie)",
    f_submit: "Wyślij aplikację",
    f_sending: "Wysyłanie...",
    f_success: "Dziękujemy! Nasz konsultant wkrótce się odezwie.",
    f_error: "Coś poszło nie tak. Spróbuj ponownie.",
    exp_opts: ["Mniej niż 1 rok", "1-3 lata", "3-5 lat", "5+ lat"],
    lic_opts: ["Prawo jazdy C", "Prawo jazdy CE", "C + CE", "W trakcie szkolenia"],
    avail_opts: ["Od zaraz", "W ciągu 2 tygodni", "W ciągu 1 miesiąca", "Do uzgodnienia"],
    f_certs: "Certyfikaty (zaznacz wszystkie pasujące)",
    cert_opts: ["Kod 95", "ADR Podstawowy", "ADR Cysterna", "ADR Klasa 1 (Materiały wybuchowe)", "ADR Klasa 7 (Radioaktywne)", "Wózek widłowy", "Wózek reach", "Żuraw (HDS)", "VCA (BHP)", "Karta kierowcy (tachograf)", "Tachograf cyfrowy", "Transport kontenerowy", "Transport chłodniczy", "Doświadczenie z komputerem pokładowym"],
    contact_title: "WOLISZ KONTAKT BEZPOŚREDNI?",
    contact_sub: "Zadzwoń lub wyślij nam wiadomość WhatsApp. Nasi konsultanci chętnie pomogą.",
    footer_tag: "Łączy talenty. Wzmacnia firmy. Buduje jutro.",
    footer_slogan: "Niezawodni. Zmotywowani. Nigdy w miejscu.",
    footer_about: "Northline Recruitment — agencja rekrutacji i selekcji w transporcie.",
    f_cv: "CV / dokumenty (opcjonalnie)",
    faq_tag: "FAQ", faq_title: "NAJCZĘSTSZE PYTANIA", faq_sub: "Wszystko o aplikowaniu przez Northline.",
    faq: [
      { q: "Ile to mnie kosztuje jako kandydata?", a: "Nic. Nasze pośrednictwo jest w 100% darmowe i niezobowiązujące dla kierowców." },
      { q: "Jak szybko mogę zacząć pracę?", a: "Jeśli dokumenty są w porządku, często w ciągu kilku dni po rozmowie." },
      { q: "Jakie prawo jazdy jest potrzebne?", a: "Minimum prawo jazdy C/CE z ważnym kodem 95 i kartą kierowcy." },
      { q: "Czy zatrudnia mnie bezpośrednio pracodawca?", a: "Tak. Zajmujemy się tylko rekrutacją i selekcją; umowę podpisujesz bezpośrednio z pracodawcą." },
    ],
    vac_tag: "OFERTY", vac_title: "AKTUALNE OFERTY", vac_sub: "Wybrane otwarte stanowiska. Nie ma Twojego regionu? Aplikuj mimo to.",
    vacancies: [
      { title: "Kierowca CE transport krajowy", location: "Rotterdam / Rijnmond", type: "Stała umowa" },
      { title: "Kierowca CE dystrybucja", location: "Venlo / Limburgia", type: "Stała umowa" },
      { title: "Kierowca CE transport kontenerowy", location: "Amsterdam", type: "Pełny etat" },
      { title: "Kierowca CE transport chłodniczy", location: "Tilburg / Brabancja", type: "Stała umowa" },
    ],
    cookie_text: "Używamy wyłącznie plików cookie niezbędnych do działania strony.",
    cookie_accept: "Akceptuję",
    privacy_link: "Polityka prywatności",
    privacy_title: "Polityka prywatności",
    privacy_body: "Northline Recruitment przetwarza dane podane w formularzu (imię, dane kontaktowe, prawo jazdy, certyfikaty, doświadczenie i ewentualnie CV) wyłącznie w celu pośrednictwa pracy. Dane udostępniamy potencjalnym pracodawcom tylko za Twoją zgodą i nie przechowujemy ich dłużej niż to konieczne. W każdej chwili możesz poprosić o wgląd, poprawienie lub usunięcie danych pod adresem gilano@northlinerecruitment.nl.",
    reviews_tag: "OPINIE",
    reviews_title: "CO MÓWIĄ KIEROWCY",
    reviews_sub: "Prawdziwe doświadczenia kierowców, których zatrudniliśmy.",
    reviews_rating_label: "średnia ocena",
    reviews: [
      { name: "Jan de Vries", role: "Kierowca CE, Rotterdam", text: "W ciągu tygodnia miałem stałą umowę w świetnej firmie transportowej. Northline załatwił wszystko, a komunikacja była super.", rating: 5 },
      { name: "Marek Kowalski", role: "Kierowca CE, Venlo", text: "Profesjonalna opieka od początku do końca. Mój konsultant informował mnie o wszystkim. Naprawdę polecam!", rating: 5 },
      { name: "Dennis Bakker", role: "Kierowca CE, Tilburg", text: "Szukałem pracy bliżej domu i Northline znalazł dokładnie to, czego chciałem. Szybko, uczciwie i osobiście.", rating: 5 },
      { name: "Piotr Nowak", role: "Kierowca CE, Amsterdam", text: "Wszystko dobrze załatwione, także moje papiery ADR. Wynagrodzenie lepsze niż się spodziewałem. Dzięki Northline!", rating: 5 },
      { name: "Ahmed El Amrani", role: "Kierowca CE, Utrecht", text: "Wreszcie agencja, która słucha. Bez pustych obietnic, po prostu dobra praca.", rating: 4 },
      { name: "Tomasz Wójcik", role: "Kierowca CE, Eindhoven", text: "Szybka reakcja i wszystko porządnie na papierze. Teraz jeżdżę z przyjemnością dla dobrego pracodawcy.", rating: 5 },
    ],
  },
};
